import type { TranslationResource } from './en';

export const ar: TranslationResource = {
  title: 'AutoCut - برنامج التثبيت',
  downloading: 'جارٍ تنزيل AutoCut',
  downloadedTitle: 'تم تنزيل AutoCut بنجاح !',
  closingCountdown: 'سيتم الإغلاق خلال {{count}} ثانية',
  alreadyInstalledTitle: 'AutoCut مثبت بالفعل',
  alreadyInstalledHelp:
    'يعمل AutoCut الآن كتطبيق سطح مكتب. يمكنك إلغاء تثبيت هذا الملحق من تطبيق Creative Cloud.',
};
